import './styles/main.css';
import {AppManagerBillingPage} from './app-manager-billing-page.js';
import {PlanCardSlider} from './components/custom/plan-card-slider.js';
import {PlanTable} from './components/custom/plan-table.js';
import {AppButton} from './components/custom/button.js';

import {AppManagerBillingPagePolaris} from "./app-manager-billing-page-polaris.js";
import {PlanCardSliderPolaris} from "./components/polaris/plan-card-slider.js";
import {PlanTablePolaris} from "./components/polaris/plan-table.js";

export async function init({autoRegister = true} = {}) {
    if (autoRegister) {
        if (!customElements.get('app-manager-billing-page')) {
            customElements.define('app-manager-billing-page', AppManagerBillingPage);
        }
        if (!customElements.get('plan-card-slider')) {
            customElements.define('plan-card-slider', PlanCardSlider);
        }
        if (!customElements.get('plan-table')) {
            customElements.define('plan-table', PlanTable);
        }
        if (!customElements.get('app-button')) {
            customElements.define('app-button', AppButton);
        }
        if (!customElements.get('app-manager-billing-page-polaris')) {
            customElements.define('app-manager-billing-page-polaris', AppManagerBillingPagePolaris);
        }
        if (!customElements.get('plan-card-slider-polaris')) {
            customElements.define('plan-card-slider-polaris', PlanCardSliderPolaris);
        }
        if (!customElements.get('plan-table-polaris')) {
            customElements.define('plan-table-polaris', PlanTablePolaris);
        }
    }
}

export {AppManagerBillingPage, PlanCardSlider, PlanTable, AppButton, AppManagerBillingPagePolaris, PlanCardSliderPolaris, PlanTablePolaris};
